import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { fetchPricingPlans } from "./pricingPlans.thunk";
import { formatPricingPlansDto } from "../../helpers";

const pricingPlansSlice = createSlice({
  name: "pricingPlans",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPricingPlans.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPricingPlans.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.data = formatPricingPlansDto(action.payload);
      })
      .addCase(fetchPricingPlans.rejected, (state) => {
        state.isLoading = false;
        state.error = "Failed to fetch pricing plans";
      });
  },
});

export default pricingPlansSlice.reducer;
